module.exports = __webpack_public_path__ + "static/media/2019_06_19_polityka_prywatnosci.96243535.pdf";